/**Dependencies */
import React, { useEffect, useState } from "react";

/**Components */
import { Row, Col, Card } from "react-bootstrap";

/**Images */
import { FaStar } from "react-icons/fa6";
import { Currency, totalPrices } from "../helpers";
import { useNavigate } from "react-router-dom";
import { comisionUser } from "../services/LoginService";

export const CardCarrousel = ({
  dataInfo,
  seccion,
  nights,
  markup,
  selectedDates,
}) => {
  const [comisionUsuario, setComisionUsuario] = useState(0);
  const [userData] = useState(
    JSON.parse(localStorage.getItem("dataUser") || 0)
  );
  useEffect(() => {
    const comision = async () => {
      try {
        if (userData?.usuario?.id) {
          const response = await comisionUser(userData?.usuario?.id);
          setComisionUsuario(response);
        } else {
          setComisionUsuario(0);
        }
      } catch (error) {
        throw new Error("error connection: " + error);
      }
    };

    comision();
  }, [userData]);

  const getStarCount = (categoriaId) => {
    const starMatch = categoriaId?.match(/\d+/); // Busca el número al inicio de la cadena
    return starMatch ? parseInt(starMatch[0], 10) : 0; // Devuelve el número de estrellas
  };
  const navigate = useNavigate();
  const HotelStars = ({ categoriaId }) => {
    const totalStars = 5; // Siempre queremos mostrar 5 estrellas
    const starCount = getStarCount(categoriaId); // Obtener el número de estrellas activas
    // Crear un arreglo de 5 estrellas, donde las primeras `starCount` sean destacadas y el resto en gris
    const stars = <span>{starCount}</span>;

    return <div className="section-stars">{stars}</div>;
  };
  return (
    <>
      {seccion === "infoHotel" ? (
        <Card
          className="card-hotels d-flex mb-4 justify-content-center"
          style={{ width: "15rem", height: "25rem", border: "0" }}
        >
          <Card.Img
            variant="top"
            src={"http://photos.hotelbeds.com/giata/bigger/" + dataInfo?.foto}
            style={{
              height: "14rem",
              borderRadius: "0.5rem",
              marginBottom: "0.5rem",
              cursor: "pointer",
            }}
            onClick={() => [
              window.scrollTo({ top: 0, behavior: "smooth" }),

              navigate(
                `/info-hotel?idHotel=${dataInfo?.id}&in=${selectedDates?.[0]}&out=${selectedDates?.[1]}&hab=1&pax1=2|0|0`
              ),
            ]}
          />
          {/* <div
            className="bg-white position-absolute"
            style={{
              top: "6%",
              borderRadius: "0px 35px 35px 0px",
              opacity: ".85",
            }}
          >
            <p
              style={{ fontSize: "10px", padding: "10px", fontWeight: "700" }}
              className="text-promocion m-0"
            >
              PROMOCIÓN VÁLIDA DEL <br /> 3 AL 6 DE OCTUBRE 2024
            </p>
          </div> */}
          <Card.Body className="shadow" style={{ borderRadius: "0.5rem" }}>
            <Row>
              <Col lg={12}>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <p className="m-0 d-flex align-items-center text-highlight">
                    {/* <FaStar />
                    <HotelStars categoriaId={dataInfo.categoria} /> */}
                  </p>
                </div>
              </Col>
              <Col lg={12} style={{ lineHeight: "13px" }}>
                <p
                  className="text-start text-purple font-weight-bold text-highlight hotel-hover"
                  style={{ lineHeight: "19px", cursor: "pointer" }}
                  onClick={() => [
                    window.scrollTo({ top: 0, behavior: "smooth" }),

                    navigate(
                      `/info-hotel?idHotel=${dataInfo?.id}&in=${selectedDates?.[0]}&out=${selectedDates?.[1]}&hab=1&pax1=2|0|0`
                    ),
                  ]}
                >
                  {" "}
                  {dataInfo?.nombre}
                </p>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <p
                    className="text-start text-purple"
                    style={{ fontSize: "14px" }}
                  >
                    {dataInfo?.zona}
                  </p>
                  <p
                    className="d-flex align-items-center text-highlight"
                    style={{ fontSize: "14px" }}
                  >
                    {dataInfo.categoria === "BOU" ? (
                      <>BOUTIQUE</>
                    ) : (
                      <>
                        <FaStar />{" "}
                        <HotelStars categoriaId={dataInfo.categoria} />
                        .0
                      </>
                    )}
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col
                lg={12}
                className="text-start text-purple"
                style={{ lineHeight: "0px", cursor: "pointer" }}
                onClick={() => [
                  window.scrollTo({ top: 0, behavior: "smooth" }),

                  navigate(
                    `/info-hotel?idHotel=${dataInfo?.id}&in=${selectedDates?.[0]}&out=${selectedDates?.[1]}&hab=1&pax1=2|0|0`
                  ),
                ]}
              >
                <p>Precio por noche desde:</p>
                <h1
                  className="font-weight-bold text-highlight hotel-hover"
                  style={{ fontSize: "1.5rem" }}
                >
                  {comisionUsuario?.hoteleria && (
                    <>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#8e8e8e",
                          textDecoration: "line-through",
                        }}
                      >
                        {Currency(
                          totalPrices(dataInfo?.precio, markup, nights)[0]
                        )}{" "}
                        MXN
                      </span>
                      <br />
                    </>
                  )}
                  {Currency(
                    totalPrices(
                      dataInfo?.precio,
                      markup,
                      nights,
                      comisionUsuario?.hoteleria
                    )[0]
                  )}{" "}
                  MXN
                </h1>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ) : seccion === "experenciasInfo" ? (
        <Card
          className="card-hotels d-flex mb-4 justify-content-center"
          style={{ width: "18rem", height: "28rem", border: "0" }}
        >
          <Card.Img
            variant="top"
            src={dataInfo?.content?.media?.images?.[0]?.urls?.[1]?.resource}
            style={{
              height: "14rem",
              borderRadius: "0.5rem",
              marginBottom: "0.5rem",
              cursor: "pointer",
            }}
            onClick={() => [
              window.scrollTo({ top: 0, behavior: "smooth" }),

              navigate(
                `/info-experiencia?idActividad=${dataInfo?.code}&idDestino=${dataInfo?.country?.destinations?.[0]?.code}&in=${selectedDates?.[0]}&out=${selectedDates?.[1]}&pax=2|21,21|0|0`
              ),
            ]}
          />
          <Card.Body className="shadow" style={{ borderRadius: "0.5rem" }}>
            <Row>
              <Col lg={12} style={{ lineHeight: "13px" }}>
                <p
                  className="text-start text-purple font-weight-bold text-highlight hotel-hover"
                  style={{
                    lineHeight: "19px",
                    cursor: "pointer",
                    height: "40px",
                  }}
                  onClick={() => [
                    window.scrollTo({ top: 0, behavior: "smooth" }),

                    navigate(
                      `/info-experiencia?idActividad=${dataInfo?.code}&idDestino=${dataInfo?.country?.destinations?.[0]?.code}&in=${selectedDates?.[0]}&out=${selectedDates?.[1]}&pax=2|21,21|0|0`
                    ),
                  ]}
                >
                  {" "}
                  {dataInfo?.name?.substring(0, 30)}...
                </p>
                <p
                  className="text-start text-purple"
                  style={{ fontSize: "14px" }}
                >
                  {dataInfo?.content?.modalityName?.substring(0, 30)}...
                </p>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col
                lg={12}
                className="text-start text-purple"
                style={{ cursor: "pointer" }}
                onClick={() => [
                  window.scrollTo({ top: 0, behavior: "smooth" }),

                  navigate(
                    `/info-experiencia?idActividad=${dataInfo?.code}&idDestino=${dataInfo?.country?.destinations?.[0]?.code}&in=${selectedDates?.[0]}&out=${selectedDates?.[1]}&pax=2|21,21|0|0`
                  ),
                ]}
              >
                <p
                  className="font-weight-bold m-0 text-highlight hotel-hover"
                  // style={{  }}
                >
                  Desde <br />
                  {comisionUsuario?.actividades && (
                    <>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#8e8e8e",
                          textDecoration: "line-through",
                        }}
                      >
                        {Currency(
                          totalPrices(
                            dataInfo?.amountsFrom?.find(
                              (amountPax) => amountPax?.paxType === "ADULT"
                            )?.amount,
                            markup,
                            nights
                          )[1]
                        )}{" "}
                        MXN
                      </span>
                      <br />
                    </>
                  )}
                  {Currency(
                    totalPrices(
                      dataInfo?.amountsFrom?.find(
                        (amountPax) => amountPax?.paxType === "ADULT"
                      )?.amount,
                      markup,
                      nights,
                      comisionUsuario?.actividades
                    )[1]
                  ) + " MXN"}{" "}
                  por persona
                </p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ) : seccion === "dinamicHotels" ? (
        <Card
          className="card-hotels d-flex mb-4 justify-content-center p-3"
          style={{ width: "18rem", height: "28rem", border: "0" }}
        >
          <Card.Img
            variant="top"
            src={
              "https://panel.marzahtravel.com/assets/uploads/carruseles/hoteles/" +
              dataInfo?.url
            }
            style={{
              height: "14rem",
              borderRadius: "0.5rem",
              marginBottom: "0.5rem",
            }}
          />
          {/* <div
            className="bg-white position-absolute"
            style={{
              top: "6%",
              borderRadius: "0px 35px 35px 0px",
              opacity: ".85",
            }}
          >
            <p
              style={{ fontSize: "10px", padding: "10px", fontWeight: "700" }}
              className="text-promocion m-0"
            >
              PROMOCIÓN VÁLIDA DEL <br /> 3 AL 6 DE OCTUBRE 2024
            </p>
          </div> */}
          <Card.Body
            className="shadow"
            style={{ borderRadius: "0.5rem", height: "12rem" }}
          >
            <Row>
              <Col lg={12} style={{ lineHeight: "13px" }}>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  {/* <p className="m-0">Todo Incluído</p> */}
                  <p
                    className="text-start text-purple m-0"
                    style={{ fontSize: "14px" }}
                  >
                    {dataInfo?.zona}
                  </p>
                  <p
                    className="m-0 d-flex align-items-center text-highlight"
                    onClick={() => [
                      window.scrollTo({ top: 0, behavior: "smooth" }),

                      navigate(
                        `/info-hotel?idHotel=${dataInfo?.id}&in=${selectedDates?.[0]}&out=${selectedDates?.[1]}&hab=1&pax1=2|0|0`
                      ),
                    ]}
                    style={{ cursor: "pointer" }}
                  >
                    {dataInfo.categoria === "BOU" ? (
                      <>BOUTIQUE</>
                    ) : (
                      <>
                        <FaStar />{" "}
                        <HotelStars categoriaId={dataInfo?.categoria} />
                        .0
                      </>
                    )}
                  </p>
                </div>
                <p
                  className="text-start text-purple font-weight-bold text-highlight hotel-hover"
                  style={{
                    lineHeight: "19px",
                    cursor: "pointer",
                    height: "40px",
                  }}
                  onClick={() => [
                    window.scrollTo({ top: 0, behavior: "smooth" }),

                    navigate(
                      `/info-hotel?idHotel=${dataInfo?.id}&in=${selectedDates?.[0]}&out=${selectedDates?.[1]}&hab=1&pax1=2|0|0`
                    ),
                  ]}
                >
                  {" "}
                  {dataInfo?.nombre}
                </p>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col
                lg={12}
                className="text-start text-purple"
                // style={{ lineHeight: "0px" }}
              >
                <p className="m-0">Precio por noche desde:</p>
                <h1
                  className="font-weight-bold text-highlight hotel-hover"
                  style={{ fontSize: "1.5rem", cursor: "pointer" }}
                  onClick={() => [
                    window.scrollTo({ top: 0, behavior: "smooth" }),

                    navigate(
                      `/info-hotel?idHotel=${dataInfo?.id}&in=${selectedDates?.[0]}&out=${selectedDates?.[1]}&hab=1&pax1=2|0|0`
                    ),
                  ]}
                >
                  {comisionUsuario?.hoteleria && (
                    <>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#8e8e8e",
                          textDecoration: "line-through",
                        }}
                      >
                        {Currency(
                          totalPrices(dataInfo?.precio, markup, nights)[0]
                        )}{" "}
                        MXN
                      </span>
                      <br />
                    </>
                  )}
                  {Currency(
                    totalPrices(
                      dataInfo?.precio,
                      markup,
                      nights,
                      comisionUsuario?.hoteleria
                    )[0]
                  )}{" "}
                  MXN
                </h1>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ) : (
        <Card
          className="card-hotels d-flex mb-4 justify-content-center p-3"
          style={{ width: "18rem", height: "28rem", border: "0" }}
        >
          <Card.Img
            variant="top"
            src={dataInfo?.img}
            style={{
              height: "14rem",
              borderRadius: "0.5rem",
              marginBottom: "0.5rem",
            }}
          />
          {/* <div
            className="bg-white position-absolute"
            style={{
              top: "6%",
              borderRadius: "0px 35px 35px 0px",
              opacity: ".85",
            }}
          >
            <p
              style={{ fontSize: "10px", padding: "10px", fontWeight: "700" }}
              className="text-promocion m-0"
            >
              PROMOCIÓN VÁLIDA DEL <br /> 3 AL 6 DE OCTUBRE 2024
            </p>
          </div> */}
          <Card.Body className="shadow" style={{ borderRadius: "0.5rem" }}>
            <Row>
              <Col lg={12}></Col>
              <Col lg={12} style={{ lineHeight: "13px" }}>
                <p
                  className="text-start text-purple font-weight-bold text-highlight hotel-hover"
                  style={{ lineHeight: "19px" }}
                >
                  {" "}
                  {dataInfo?.hotel}
                </p>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  {/* <p className="m-0">Todo Incluído</p> */}
                  <p
                    className="text-start text-purple"
                    style={{ fontSize: "14px" }}
                  >
                    {dataInfo?.location}
                  </p>
                  <p className="m-0 d-flex align-items-center text-highlight">
                    <FaStar /> {dataInfo?.stars}
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col
                lg={12}
                className="text-start text-purple"
                style={{ lineHeight: "0px" }}
              >
                <p>Precio por noche desde:</p>
                <h1
                  className="font-weight-bold text-highlight hotel-hover"
                  style={{ fontSize: "1.5rem" }}
                >
                  {dataInfo?.price} MXN
                </h1>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
    </>
  );
};
